import React from 'react';
import Modal, { ModalTitle, ModalActions } from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import styles from './Integrations.module.scss';

interface DisconnectModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export default function DisconnectModal({ open, onClose, onConfirm, loading }: DisconnectModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>Disconnect ShelterLuv</ModalTitle>
      <p className={styles.disconnectText}>
        Are you sure you want to disconnect your ShelterLuv integration? New adoption events will stop syncing. Chips
        already imported will remain in your inventory.
      </p>
      <ModalActions>
        <Button variant="ghost" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? 'Disconnecting...' : 'Disconnect'}
        </Button>
      </ModalActions>
    </Modal>
  );
}
